module.exports = __webpack_public_path__ + "img/bandaoti_meiguang.db91aaba.png";